import React from 'react';
import PropTypes from 'prop-types';
import Header from '../shared/header';
import Footer from '../shared/footer';
import LanguageDirection from '../shared/languageDirection';
import MainInvite from './mainInvite';
import Modal from '../shared/modal';

class InviteComponent extends React.Component {
  componentDidMount() {
    const { locale, displayModal, getTranslations, getUserInfo } = this.props;

    displayModal('');
    getUserInfo(this.props.params.accountInfo, locale);

    if (locale) {
      getTranslations(this.props.locale, true);
    } else {
      getTranslations();
    }
  }

  render() {
    const {
      alertStatus,
      autoCompleteSubmit,
      basePath,
      displayModal,
      duplicateEmails,
      emailSubmit,
      enterPush,
      error,
      expandTextArea,
      inputAreaHeight,
      invites,
      invitesInfoReceived,
      locale,
      modalOnDisplay,
      removeDuplicates,
      resendDuplicates,
      restrictedEmails,
      spinnerDisplay,
      translations,
    } = this.props;

    const shouldModalDisplay =
      modalOnDisplay === 'invite-suggestion' ||
      modalOnDisplay === 'duplicates' ||
      modalOnDisplay === 'restricted';

    return (
      <div>
        <LanguageDirection locale={locale}>
          <Header logo={invites.logo} />
          {alertStatus && (
            <div className="alert">{translations['invitations-sent']}</div>
          )}
          {invitesInfoReceived && (
            <MainInvite
              translations={translations}
              invites={invites}
              error={error}
              spinnerDisplay={spinnerDisplay}
              inputAreaHeight={inputAreaHeight}
              emailSubmit={emailSubmit}
              displayModal={displayModal}
              enterPush={enterPush}
              expandTextArea={expandTextArea}
              basePath={basePath}
              autoCompleteSubmit={autoCompleteSubmit}
              modalOnDisplay={modalOnDisplay}
            />
          )}
          {!invitesInfoReceived && <div className="loading" />}
          {shouldModalDisplay && (
            <Modal
              invites={invites}
              modalOnDisplay={modalOnDisplay}
              displayModal={displayModal}
              translations={translations}
              color={invites.program.color}
              duplicateEmails={duplicateEmails}
              removeDuplicates={removeDuplicates}
              resendDuplicates={resendDuplicates}
              restrictedEmails={restrictedEmails}
              error={error}
            />
          )}
          <Footer
            translations={this.props.translations}
            updateLocale={this.props.updateLocale}
            privacyPolicyLink={this.props.privacyPolicyLink}
            locale={this.props.locale}
          />
        </LanguageDirection>
      </div>
    );
  }
}

InviteComponent.propTypes = {
  alertStatus: PropTypes.bool,
  autoCompleteSubmit: PropTypes.func,
  basePath: PropTypes.string,
  displayModal: PropTypes.func,
  duplicateEmails: PropTypes.shape({
    emails: PropTypes.array,
    resendUrl: PropTypes.string,
    delayDisplayAlert: PropTypes.bool,
  }),
  emailSubmit: PropTypes.func,
  enterPush: PropTypes.func,
  error: PropTypes.string,
  expandTextArea: PropTypes.func,
  getTranslations: PropTypes.func.isRequired,
  getUserInfo: PropTypes.func.isRequired,
  inputAreaHeight: PropTypes.string,
  invites: PropTypes.shape({
    logo: PropTypes.string,
    program: PropTypes.shape({
      color: PropTypes.string
    })
  }).isRequired,
  invitesInfoReceived: PropTypes.bool.isRequired,
  locale: PropTypes.string,
  modalOnDisplay: PropTypes.string.isRequired,
  params: PropTypes.shape({
    accountInfo: PropTypes.shape({}),
  }),
  privacyPolicyLink: PropTypes.string,
  removeDuplicates: PropTypes.func,
  resendDuplicates: PropTypes.func,
  restrictedEmails: PropTypes.array,
  spinnerDisplay: PropTypes.bool,
  translations: PropTypes.objectOf(PropTypes.string).isRequired,
  updateLocale: PropTypes.func,
};

InviteComponent.defaultProps = {
  alertStatus: false,
  autoCompleteSubmit: () => {},
  basePath: '',
  displayModal: () => {},
  duplicateEmails: {},
  emailSubmit: () => {},
  enterPush: () => {},
  error: '',
  expandTextArea: () => {},
  inputAreaHeight: '',
  locale: '',
  params: {},
  privacyPolicyLink: '',
  removeDuplicates: () => {},
  resendDuplicates: () => {},
  restrictedEmails: [],
  spinnerDisplay: false,
  updateLocale: '',
};

export default InviteComponent;
